import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { axios, BACKEND_URL };

const http = axios.create({ baseURL: API });

export const authedClient = (token) => {
  const inst = axios.create({ baseURL: API });
  if (token) inst.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return inst;
};

export const api = {
  // Articles
  listArticles: (params = {}) => http.get("/articles", { params }).then((r) => r.data),
  getArticle: (id) => http.get(`/articles/${id}`).then((r) => r.data),
  getReactions: (articleId) => http.get(`/articles/${articleId}/reactions`).then((r) => r.data),

  // Comments
  listComments: (articleId) => http.get(`/articles/${articleId}/comments`).then((r) => r.data),
  addComment: (token, articleId, payload) =>
    authedClient(token).post(`/articles/${articleId}/comments`, payload).then((r) => r.data),

  // Public lists
  listTimeline: () => http.get("/timeline").then((r) => r.data),
  listEvents: () => http.get("/events").then((r) => r.data),
  getEvent: (id) => http.get(`/events/${id}`).then((r) => r.data),
  listRares: () => http.get("/rares").then((r) => r.data),
  listRareCategories: () => http.get("/rares/categories").then((r) => r.data),
  listTeam: () => http.get("/team").then((r) => r.data),
  listHeaders: () => http.get("/headers").then((r) => r.data),
  listHotels: () => http.get("/hotels").then((r) => r.data),
  listBadges: () => http.get("/badges").then((r) => r.data),
  latestBadges: (limit = 10) => http.get(`/badges/latest?limit=${limit}`).then((r) => r.data),
  getBadgeOverview: (code) => http.get(`/badges/${code}/overview`).then((r) => r.data),
  getStats: () => http.get("/stats").then((r) => r.data),
  getSettings: () => http.get("/settings").then((r) => r.data),
  badgeGamedata: (code, hotel) => http.get(`/badges/gamedata/${encodeURIComponent(code)}${hotel ? `?hotel=${hotel}` : ""}`).then((r) => r.data),
  badgeGamedataAll: (code) => http.get(`/badges/gamedata-all/${encodeURIComponent(code)}`).then((r) => r.data),

  // Habbos
  randomHabbos: (count = 10) => http.get(`/habbos/random?count=${count}`).then((r) => r.data),
  heroFloaters: (count = 12) => http.get(`/hero/floaters?count=${count}`).then((r) => r.data),
  listHabbos: () => http.get("/habbos").then((r) => r.data),

  // Projects
  listProjects: () => http.get("/projects").then((r) => r.data),
  getProject: (slug) => http.get(`/projects/${slug}`).then((r) => r.data),

  // Furniture (HabboAssets scrape) + Badge-Suche
  listFurniture: (q = "", page = 1, pages = 1) => http.get("/furniture", { params: { q, page, pages } }).then((r) => r.data),
  latestFurniture: (limit = 20) => http.get("/furniture/latest", { params: { limit } }).then((r) => r.data),
  furnitureSwfUrl: (classname) => `${API}/furniture/swf/${encodeURIComponent(classname)}`,
  furnitureDetail: (key) => http.get(`/furniture/detail/${encodeURIComponent(key)}`).then((r) => r.data),
  habboassetsBadges: (params = {}) => http.get("/habboassets/badges", { params }).then((r) => r.data),

  // Points & Leaderboard & Shop
  leaderboard: (limit = 50) => http.get("/leaderboard", { params: { limit } }).then((r) => r.data),
  myPoints: (token) => http.get("/users/me/points", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  updateMyPrefs: (token, payload) => http.put("/users/me/prefs", payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  listShop: () => http.get("/shop").then((r) => r.data),
  redeemShop: (token, itemId) => http.post(`/shop/redeem/${itemId}`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  setActiveGlow: (token, slug) => http.put("/shop/active-glow", { slug }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  userProfile: (habboName) => http.get(`/users/profile/${encodeURIComponent(habboName)}`).then((r) => r.data),
};

// User-authed API (User-Token oder Admin-Token funktionieren)
export const authedApi = (token) => {
  const c = axios.create({ baseURL: API, headers: { Authorization: `Bearer ${token}` } });
  return {
    // Stories
    submitStory: (p) => c.post("/stories", p).then((r) => r.data),
    listMyStories: () => c.get("/stories/mine").then((r) => r.data),
    getStory: (id) => c.get(`/stories/${id}`).then((r) => r.data),
    listStoryMessages: (id) => c.get(`/stories/${id}/messages`).then((r) => r.data),
    postStoryMessage: (id, text) => c.post(`/stories/${id}/messages`, { text }).then((r) => r.data),
    listStories: () => c.get("/stories").then((r) => r.data),
    updateStory: (id, p) => c.patch(`/stories/${id}`, p).then((r) => r.data),
    // Team Chat
    listTeamChat: (limit = 100) => c.get(`/team/chat?limit=${limit}`).then((r) => r.data),
    postTeamChat: (text) => c.post("/team/chat", { text }).then((r) => r.data),
    deleteTeamChat: (id) => c.delete(`/team/chat/${id}`).then((r) => r.data),
    // News-Reactions (eingeloggt)
    reactArticle: (articleId, emoji) => c.post(`/articles/${articleId}/react`, { emoji }).then((r) => r.data),
    // Notifications
    listNotifications: () => c.get("/notifications").then((r) => r.data),
    markNotificationRead: (id) => c.patch(`/notifications/${id}/read`).then((r) => r.data),
    markAllRead: () => c.patch("/notifications/read-all").then((r) => r.data),
    // Moderation
    listModeratedComments: (status) => c.get(`/cms/moderation/comments${status ? `?status=${status}` : ""}`).then((r) => r.data),
    restoreComment: (id) => c.put(`/cms/comments/${id}/restore`).then((r) => r.data),
    // Profil-Hintergruende
    myBackgrounds: () => c.get("/me/backgrounds").then((r) => r.data),
    setActiveBackground: (slug) => c.put("/shop/active-background", { slug }).then((r) => r.data),
    // Kommentar-Badge
    myAvailableBadges: () => c.get("/users/me/available-badges").then((r) => r.data),
    setCommentBadge: (badge_code) => c.put("/users/me/comment-badge", { badge_code }).then((r) => r.data),
  };
};

export const adminApi = (token) => {
  const c = authedClient(token);
  return {
    // Articles
    listArticles: () => c.get("/articles").then((r) => r.data),
    createArticle: (p) => c.post("/admin/articles", p).then((r) => r.data),
    updateArticle: (id, p) => c.put(`/admin/articles/${id}`, p).then((r) => r.data),
    deleteArticle: (id) => c.delete(`/admin/articles/${id}`).then((r) => r.data),

    // Multi-file Upload (Galerie)
    uploadImages: (formData) => c.post("/admin/uploads", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data),
    listUploads: (params = {}) => c.get("/admin/uploads/list", { params }).then((r) => r.data),
    deleteUpload: (name, force = false) =>
      c.delete(`/admin/uploads/${encodeURIComponent(name)}${force ? "?force=true" : ""}`).then((r) => r.data),

    // Web-Promos (Habbo lpromo Bibliothek)
    listWebPromos: ({ q = "", skip = 0, limit = 60, only_favorites = false } = {}) =>
      c.get(`/admin/web-promos`, { params: { q, skip, limit, only_favorites } }).then((r) => r.data),
    refreshWebPromos: () => c.post("/admin/web-promos/refresh").then((r) => r.data),
    toggleWebPromoFavorite: (name, favorite) =>
      c.post("/admin/web-promos/favorite", { name, favorite }).then((r) => r.data),

    // Habbo-Article-Images Pool
    listHabboImages: ({ q = "", skip = 0, limit = 100, source = "" } = {}) =>
      c.get("/admin/habbo-images", { params: { q, skip, limit, source } }).then((r) => r.data),
    addHabboImages: (urls, note) =>
      c.post("/admin/habbo-images", { urls, note }).then((r) => r.data),
    deleteHabboImage: (id) =>
      c.delete(`/admin/habbo-images/${id}`).then((r) => r.data),
    refreshHabboImages: () =>
      c.post("/admin/habbo-images/refresh").then((r) => r.data),

    // Furni-Neuheiten (HabboAssets scrape + Icon-Save)
    latestFurniture: (limit = 50) =>
      c.get("/furniture/latest", { params: { limit } }).then((r) => r.data),
    saveFurnitureIcon: (classname) =>
      c.post("/admin/furniture/save-icon", { classname }).then((r) => r.data),

    // AI-News-Import
    aiNewsFeed: (hotel = "de") => c.get("/admin/ai-news/feed", { params: { hotel } }).then((r) => r.data),
    aiNewsHotels: () => c.get("/admin/ai-news/hotels").then((r) => r.data),
    aiNewsImport: (payload) => c.post("/admin/ai-news/import", payload).then((r) => r.data),
    aiNewsDeleteImport: (guid) => c.delete(`/admin/ai-news/${encodeURIComponent(guid)}`).then((r) => r.data),

    // Rares CMS (Permission rares_edit)
    listRaresCms: () => c.get("/cms/rares").then((r) => r.data),
    createRareCms: (p) => c.post("/cms/rares", p).then((r) => r.data),
    updateRareCms: (id, p) => c.put(`/cms/rares/${id}`, p).then((r) => r.data),
    deleteRareCms: (id) => c.delete(`/cms/rares/${id}`).then((r) => r.data),

    // Profil-Hintergruende (Admin)
    createBackground: (p) => c.post("/admin/shop/backgrounds", p).then((r) => r.data),
    deleteShopItem: (id) => c.delete(`/admin/shop/${id}`).then((r) => r.data),

    // Furniture CMS (Permission furniture_edit)
    listFurnitureCms: () => c.get("/cms/furniture").then((r) => r.data),
    createFurnitureCms: (p) => c.post("/cms/furniture", p).then((r) => r.data),
    updateFurnitureCms: (id, p) => c.put(`/cms/furniture/${id}`, p).then((r) => r.data),
    deleteFurnitureCms: (id) => c.delete(`/cms/furniture/${id}`).then((r) => r.data),

    // Reviewer-Dashboard (Permission news_review)
    reviewQueue: () => c.get("/cms/review-queue").then((r) => r.data),
    approveArticle: (id) => c.post(`/cms/review/${id}/approve`).then((r) => r.data),
    togglePublishArticle: (id, published) => c.post(`/cms/articles/${id}/toggle-publish`, { published }).then((r) => r.data),
    rejectArticle: (id) => c.post(`/cms/review/${id}/reject`).then((r) => r.data),

    // Points
    awardPoints: (userId, amount, reason) => c.post(`/admin/users/${userId}/points/award`, { amount, reason }).then((r) => r.data),

    // Shop
    listShop: () => c.get("/admin/shop").then((r) => r.data),
    updateShopItem: (id, p) => c.put(`/admin/shop/${id}`, p).then((r) => r.data),

    // Timeline
    listTimeline: () => c.get("/admin/timeline").then((r) => r.data),
    createTimeline: (p) => c.post("/admin/timeline", p).then((r) => r.data),
    updateTimeline: (id, p) => c.put(`/admin/timeline/${id}`, p).then((r) => r.data),
    deleteTimeline: (id) => c.delete(`/admin/timeline/${id}`).then((r) => r.data),

    // Team
    listTeam: () => c.get("/admin/team").then((r) => r.data),
    createTeam: (p) => c.post("/admin/team", p).then((r) => r.data),
    updateTeam: (id, p) => c.put(`/admin/team/${id}`, p).then((r) => r.data),
    deleteTeam: (id) => c.delete(`/admin/team/${id}`).then((r) => r.data),

    // Habbos
    listHabbos: () => c.get("/admin/habbos").then((r) => r.data),
    createHabbo: (p) => c.post("/admin/habbos", p).then((r) => r.data),
    updateHabbo: (id, p) => c.put(`/admin/habbos/${id}`, p).then((r) => r.data),
    deleteHabbo: (id) => c.delete(`/admin/habbos/${id}`).then((r) => r.data),

    // Projects
    listProjects: () => c.get("/admin/projects").then((r) => r.data),
    createProject: (p) => c.post("/admin/projects", p).then((r) => r.data),
    updateProject: (id, p) => c.put(`/admin/projects/${id}`, p).then((r) => r.data),
    deleteProject: (id) => c.delete(`/admin/projects/${id}`).then((r) => r.data),
    addMember: (pid, m) => c.post(`/admin/projects/${pid}/members`, m).then((r) => r.data),
    updateMember: (pid, mid, m) => c.put(`/admin/projects/${pid}/members/${mid}`, m).then((r) => r.data),
    removeMember: (pid, mid) => c.delete(`/admin/projects/${pid}/members/${mid}`).then((r) => r.data),

    // Users (Admin User-Editor)
    listUsers: () => c.get("/admin/users").then((r) => r.data),
    updateUser: (id, p) => c.put(`/admin/users/${id}`, p).then((r) => r.data),
    resetUserPassword: (id, new_password) => c.post(`/admin/users/${id}/reset-password`, { new_password }).then((r) => r.data),
    regenerateUserCode: (id) => c.post(`/admin/users/${id}/regenerate-code`).then((r) => r.data),
    deleteUser: (id) => c.delete(`/admin/users/${id}`).then((r) => r.data),

    // Badges
    listBadges: () => c.get("/admin/badges").then((r) => r.data),
    createBadge: (p) => c.post("/admin/badges", p).then((r) => r.data),
    updateBadge: (id, p) => c.put(`/admin/badges/${id}`, p).then((r) => r.data),
    deleteBadge: (id) => c.delete(`/admin/badges/${id}`).then((r) => r.data),

    // Rares
    listRares: () => c.get("/admin/rares").then((r) => r.data),
    createRare: (p) => c.post("/admin/rares", p).then((r) => r.data),
    updateRare: (id, p) => c.put(`/admin/rares/${id}`, p).then((r) => r.data),
    deleteRare: (id) => c.delete(`/admin/rares/${id}`).then((r) => r.data),

    // Settings
    getSettings: () => c.get("/settings").then((r) => r.data),
    updateSettings: (p) => c.put("/admin/settings", p).then((r) => r.data),

    // User Permissions
    updatePermissions: (id, p) => c.put(`/admin/users/${id}/permissions`, p).then((r) => r.data),

    // CMS (Permission-basiert: Admin oder User mit Rechten)
    cmsMe: () => c.get("/cms/me").then((r) => r.data),
    cmsListArticles: () => c.get("/cms/articles").then((r) => r.data),
    cmsCreateArticle: (p) => c.post("/cms/articles", p).then((r) => r.data),
    cmsUpdateArticle: (id, p) => c.put(`/cms/articles/${id}`, p).then((r) => r.data),
    cmsDeleteArticle: (id) => c.delete(`/cms/articles/${id}`).then((r) => r.data),
    cmsApprove: (id) => c.post(`/cms/articles/${id}/approve`).then((r) => r.data),
    cmsToggleSticky: (id, sticky) => c.post(`/cms/articles/${id}/sticky`, { sticky }).then((r) => r.data),
    cmsMyComments: () => c.get("/cms/my-comments").then((r) => r.data),

    // Events (CMS - events_edit / admin)
    cmsListEvents: () => c.get("/cms/events").then((r) => r.data),
    cmsCreateEvent: (p) => c.post("/cms/events", p).then((r) => r.data),
    cmsUpdateEvent: (id, p) => c.put(`/cms/events/${id}`, p).then((r) => r.data),
    cmsDeleteEvent: (id) => c.delete(`/cms/events/${id}`).then((r) => r.data),

    // CMS Projects/Badges/Rares (Content-Team)
    cmsCreateProject: (p) => c.post("/cms/projects", p).then((r) => r.data),
    cmsUpdateProject: (id, p) => c.put(`/cms/projects/${id}`, p).then((r) => r.data),
    cmsDeleteProject: (id) => c.delete(`/cms/projects/${id}`).then((r) => r.data),
    cmsAddMember: (pid, m) => c.post(`/cms/projects/${pid}/members`, m).then((r) => r.data),
    cmsRemoveMember: (pid, mid) => c.delete(`/cms/projects/${pid}/members/${mid}`).then((r) => r.data),
    cmsCreateBadge: (p) => c.post("/cms/badges", p).then((r) => r.data),
    cmsUpdateBadge: (id, p) => c.put(`/cms/badges/${id}`, p).then((r) => r.data),
    cmsDeleteBadge: (id) => c.delete(`/cms/badges/${id}`).then((r) => r.data),
    cmsCreateRare: (p) => c.post("/cms/rares", p).then((r) => r.data),
    cmsUpdateRare: (id, p) => c.put(`/cms/rares/${id}`, p).then((r) => r.data),
    cmsDeleteRare: (id) => c.delete(`/cms/rares/${id}`).then((r) => r.data),
    cmsReviewCount: () => c.get("/cms/review-count").then((r) => r.data),

    // Comment Moderation
    hideComment: (id, reason) => c.put(`/cms/comments/${id}/hide`, { reason }).then((r) => r.data),
    deleteComment: (id, reason) => c.put(`/cms/comments/${id}/delete`, { reason }).then((r) => r.data),
    restoreComment: (id) => c.put(`/cms/comments/${id}/restore`).then((r) => r.data),

    // Audit Log (paginiert + filter)
    listAuditLog: ({ limit = 50, skip = 0, q = "", action = "" } = {}) =>
      c.get("/admin/audit-log", { params: { limit, skip, q, action } }).then((r) => r.data),
    // Hero-Floaters (Iter51)
    listHeroFloaters: () => c.get("/admin/hero-floaters").then((r) => r.data),
    createHeroFloater: (payload) => c.post("/admin/hero-floaters", payload).then((r) => r.data),
    updateHeroFloater: (id, payload) => c.put(`/admin/hero-floaters/${id}`, payload).then((r) => r.data),
    deleteHeroFloater: (id) => c.delete(`/admin/hero-floaters/${id}`).then((r) => r.data),
    undoAuditEntry: (entryId) =>
      c.post(`/admin/audit-log/${entryId}/undo`).then((r) => r.data),

    // Twitter-Anbindung (Iter51e)
    twitterStatus: () => c.get("/admin/twitter/status").then((r) => r.data),
    twitterConnect: () => c.post("/admin/twitter/connect").then((r) => r.data),
    twitterDisconnect: () => c.post("/admin/twitter/disconnect").then((r) => r.data),
    twitterUpdateSettings: (payload) => c.put("/admin/twitter/settings", payload).then((r) => r.data),
    twitterTestTweet: (text) => c.post("/admin/twitter/test-tweet", { text }).then((r) => r.data),
    twitterRetweetArticle: (articleId) => c.post(`/admin/twitter/retweet-article/${articleId}`).then((r) => r.data),

    // Hot Topic
    setHotTopic: (article_id, label) => c.put("/admin/hot-topic", { article_id, label }).then((r) => r.data),
  };
};

// User-API: nur eingeloggter User darf Preferences updaten
export const userApi = (token) => {
  const c = axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${token}` },
  });
  return {
    updatePreferences: (p) => c.put("/users/me/preferences", p).then((r) => r.data),
  };
};

export default api;
